/**
 * Validador padrão de CPF (algoritmo Receita Federal).
 * @param {string} cpf - CPF com ou sem máscara
 * @returns {boolean} true quando o CPF é válido (ou vazio)
 */
export const validarCPF = (cpf) => {
  const nums = String(cpf || "").replace(/\D/g, "");
  if (nums.length === 0) return true; // vazio = não obrigatório
  if (nums.length !== 11) return false;
  if (/^(\d)\1+$/.test(nums)) return false; // todos iguais (111.111.111-11)

  // Primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(nums.charAt(i)) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(nums.charAt(9))) return false;

  // Segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(nums.charAt(i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(nums.charAt(10))) return false;

  return true;
};
